var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<button ng-class=\"{ blue: $ctrl.blue }\" ng-click=\"$ctrl.share()\" class=\"button secondary facebook-share-button\">Share on Facebook</button>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-facebook-share-button.jade
 ** module id = 3467
 ** module chunks = 3
 **/